import { isAxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ConfirmationDialog } from '@dhl/confirmation-dialog'
import { Body1 } from '@dhl-ui/components'

import { postData } from '~/api/admin-api'
import { links } from '~/AppRoutes'
import { useNotificationMessage } from '~/common'

type Props = {
  open: boolean
  userId: string
  onClose: () => void
}

export const ServicepointVendorDangerZoneDialog = ({ open, userId, onClose }: Props) => {
  const navigate = useNavigate()
  const { showSuccess, showError } = useNotificationMessage()
  const { t } = useTranslation()

  const handleDelete = async () => {
    try {
      await postData(`vendors/${userId}`, 'DELETE', undefined)
      showSuccess(t('admin.servicePointVendorsPage.deleteServicePointVendorSuccess'))
      navigate(links.servicePointVendorsLink())
    } catch (error) {
      if (isAxiosError(error)) {
        showError(error.message)
      }
    }
  }

  return (
    <ConfirmationDialog
      open={open}
      titleText={t(`admin.servicePointVendorsPage.servicePointVendorsDangerZoneDialogs.header`)}
      acceptText={t(`admin.servicePointVendorsPage.servicePointVendorsDangerZoneDialogs.deleteButton`)}
      rejectText={t(`admin.servicePointVendorsPage.servicePointVendorsDangerZoneDialogs.cancelButton`)}
      onAccept={handleDelete}
      onReject={onClose}
      data-testid="confirmationDangerDialog"
    >
      <Body1>{t(`admin.servicePointVendorsPage.servicePointVendorsDangerZoneDialogs.message`)}</Body1>
    </ConfirmationDialog>
  )
}
